// extracted by mini-css-extract-plugin
module.exports = {"root":"ShutdownTag_root__3V78m"};